import { render, staticRenderFns } from "./Recogidas.vue?vue&type=template&id=4867df74&"
import script from "./Recogidas.vue?vue&type=script&lang=js&"
export * from "./Recogidas.vue?vue&type=script&lang=js&"
import style0 from "./Recogidas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports